module.exports = __webpack_public_path__ + "img/toubiao.a1082c12.png";